<template>
  <div class="login-wrap">
    <div class="login-left">
      <div class="left-content">
        <h1 class="system-title">横沙东滩稻鳖共生生产管理系统</h1>
        <p class="system-desc">
          地块种养 · 农事记录 · 进销存管理 · 农产品溯源一体化平台
        </p>
        <div class="feature-list">
          <div class="feature-item">
            <i class="el-icon-s-data"></i>
            <span>地块实时监控</span>
          </div>
          <div class="feature-item">
            <i class="el-icon-document"></i>
            <span>全流程农事记录</span>
          </div>
          <div class="feature-item">
            <i class="el-icon-s-goods"></i>
            <span>农产品产销溯源</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 右侧登录表单 -->
    <div class="login-right">
      <div class="login-box">
        <div class="login-header">
          <h2>系统登录</h2>
        </div>
        <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          label-width="0"
          class="login-form"
        >
          <!-- 账号输入 -->
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              placeholder="请输入手机号"
              prefix-icon="el-icon-user"
              :maxLength="11"
            ></el-input>
          </el-form-item>
          <!-- 密码输入 -->
          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              type="password"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
            ></el-input>
          </el-form-item>
          <!-- 登录按钮 -->
          <el-form-item>
            <el-button
              type="success"
              class="login-btn"
              @click="handleLogin"
              :loading="loading"
              >登录系统</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { hsLoginService, getCompanyList } from "@/api/request/snkd.user";
import { getAllFarmByCompanyId } from "@/api/request/snkd.produce";
import { aesEncrypt } from "@/utils/cryptoJS.js";
import { setStorage } from "@/utils/storage";
export default {
  name: "Login",
  data() {
    return {
      loading: false,
      // 登录表单数据
      loginForm: {
        username: "",
        password: "",
      },
      // 表单校验规则
      loginRules: {
        username: [
          { required: true, message: "请输入登录手机号", trigger: "blur" },
          {
            min: 11,
            max: 11,
            message: "手机号必须为11位数字",
            trigger: "blur",
          },
          // 正则格式校验
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码格式",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
          { min: 6, message: "密码长度不能少于6位", trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    // 登录提交
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        let requestData = {
          phone: aesEncrypt(this.loginForm.username),
          password: aesEncrypt(this.loginForm.password),
        };
        hsLoginService(requestData).then((res) => {
          this.loading = true;
          if (res.respCode == 0) {
            localStorage.setItem("ACCESSTOKEN", res.obj.accessToken);
            localStorage.setItem("USERID", JSON.stringify(res.obj.user.id));
            localStorage.setItem("PHONE", JSON.stringify(res.obj.user.phone));
            localStorage.removeItem("ALLPOWER");
            this.getCompanyInfo();
          } else {
            this.loading = false;
            this.$message.error(res.respDesc);
          }
        });
      });
    },

    //登录成功后 获取公司数据和农场数据

    getCompanyInfo() {
      getCompanyList().then((res) => {
        if (res.obj.list && res.obj.list.length > 0) {
          res.obj.list.forEach((item) => {
            if (item.chooseFlag == 1) {
              console.log(item.companyId);
              getAllFarmByCompanyId({ companyId: item.companyId }).then(
                (resp) => {
                  console.log(999, resp);
                  if (resp.obj && resp.obj.length > 1) {
                    resp.obj.forEach((ele) => {
                      if (ele.chooseFlag == 1) {
                        setStorage("FARMINFO", ele);
                        window.location.href = "/web-client/newHsHome";
                      }
                    });
                  } else {
                    resp.obj.forEach((ele) => {
                      setStorage("FARMINFO", ele);
                      window.location.href = "/web-client/newHsHome";
                    });
                  }
                }
              );
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-wrap {
  width: 100vw;
  height: 100vh;
  display: flex;
  overflow: hidden;
}
// 左侧宣传区域
.login-left {
  width: 55%;
  background: linear-gradient(135deg, #5cdb95 0%, #379683 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  .left-content {
    width: 80%;
    color: #fff;
    text-align: center;
    .bg-img {
      width: 320px;
      margin-bottom: 30px;
    }
    .system-title {
      font-size: 36px;
      margin: 0 0 16px;
      font-weight: 600;
    }
    .system-desc {
      font-size: 18px;
      opacity: 0.9;
      margin-bottom: 40px;
    }
    .feature-list {
      display: flex;
      justify-content: space-around;
      gap: 20px;
      .feature-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        i {
          font-size: 40px;
          margin-bottom: 10px;
        }
        span {
          font-size: 16px;
        }
      }
    }
  }
}
// 右侧登录表单
.login-right {
  width: 45%;
  background: #f7faf9;
  display: flex;
  align-items: center;
  justify-content: center;
  .login-box {
    width: 420px;
    background: #fff;
    border-radius: 12px;
    padding: 40px 36px;
    box-shadow: 0 2px 20px rgba(55, 150, 131, 0.12);
    .login-header {
      text-align: center;
      margin-bottom: 36px;
      .logo {
        width: 72px;
        margin-bottom: 12px;
      }
      h2 {
        font-size: 24px;
        color: #2d3436;
        margin: 0;
      }
    }
    .login-form {
      .el-input__inner {
        height: 44px;
        font-size: 15px;
      }
      .code-row {
        display: flex;
        gap: 10px;
        .code-img {
          width: 110px;
          height: 44px;
          background: linear-gradient(45deg, #379683, #5cdb95);
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          cursor: pointer;
          font-weight: bold;
          letter-spacing: 2px;
        }
      }
      .form-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 26px;
        .forget-pwd {
          color: #379683;
          cursor: pointer;
          font-size: 14px;
        }
      }
      .login-btn {
        width: 100%;
        height: 46px;
        font-size: 16px;
        background: linear-gradient(90deg, #379683, #5cdb95);
        border: none;
      }
      .register-tip {
        text-align: center;
        margin-top: 24px;
        font-size: 14px;
        color: #666;
        .register-text {
          color: #379683;
          cursor: pointer;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
